import { Link, useSearchParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { api } from '../api';
import NavCard from '../components/NavCard';
import '../components/NavCard.css';
import ImageCard from '../components/ImageCard';
import '../components/ImageCard.css';
import { humanizeName } from '../utils/strings';
import { useCardImages } from '../hooks/useCardImages';

export default function BrowserView() {
  const [params] = useSearchParams();
  const rel = params.get('rel') || '';
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const currentName = rel ? rel.split(/[/\\]/).pop() : '';
  const currentDisplay = humanizeName(currentName);
  const { cardImages } = useCardImages();

  useEffect(() => {
    setLoading(true);
    api(`/api/category?rel=${encodeURIComponent(rel)}`)
      .then(setData)
      .catch(setError)
      .finally(()=>setLoading(false));
  }, [rel]);
  if (loading) return <div style={{padding:16}}>Loading…</div>;
  if (error) return <div style={{padding:16,color:'red'}}>Error: {String(error)}</div>;
  if (!data) return null;
  return (
    <div style={{padding:'28px 16px 16px'}}>
      <div style={{
        position:'relative',
        display:'flex',
        alignItems:'center',
        justifyContent:'center',
        marginBottom:18
      }}>
        <Link to={-1} style={{
          position:'absolute',
          left:24,
          display:'inline-block',
          padding:'6px 12px',
          borderRadius:999,
          border:'1px solid var(--color-border)',
          textDecoration:'none',
          color:'var(--color-text)'
        }}>← <span className="back-text">Back</span></Link>
        {currentName && (
          <h2 style={{margin:0, fontSize:26}}>{humanizeName(currentName)}</h2>
        )}
      </div>
      {data.type === 'dirs' ? (
        <div className="card-grid">
          {data.items.map(d => {
            const dn = humanizeName(d.name);
            let coverUrl = undefined;
            if (currentDisplay === 'Agriculture') {
              const map = {
                'Agri Crops': cardImages.cover11,
                'Agri General': cardImages.cover12,
                'Agro Forestry': cardImages.cover13,
                'Animal Husbandry': cardImages.cover14,
                'Food Processing': cardImages.cover15,
                'Horticulture Crops': cardImages.cover16,
                'Medicinal plants': cardImages.cover17,
                'Sericulture': cardImages.cover18,
                'Working': cardImages.cover19
              };
              coverUrl = map[dn];
            } else if (currentDisplay === 'Agri Crops') {
              const map2 = {
                'Cereals': cardImages.cover111,
                'Commercial Crops': cardImages.cover112,
                'Millets': cardImages.cover113,
                'Mixed Crops': cardImages.cover114,
                'Oilseeds': cardImages.cover115,
                'Pulses': cardImages.cover116
              };
              coverUrl = map2[dn];
            } else if (currentDisplay === 'Agri General') {
              const map3 = {
                'Farmers': cardImages.cover121,
                'Field view': cardImages.cover122,
                'Inputs': cardImages.cover123,
                'Institutes': cardImages.cover124,
                'Irrigation': cardImages.cover125,
                'Labs and Depts': cardImages.cover126,
                'Machinery and Technology': cardImages.cover127,
                'Organic': cardImages.cover128,
                'Others': cardImages.cover129
              };
              coverUrl = map3[dn];
            }else if (currentDisplay === 'Animal Husbandry') {
              const map4 = {
                'Cows and Buffalos': cardImages.cover141,
                'Fodder Crops': cardImages.cover142,
                'Others': cardImages.cover143,
                'Poultry and Birds': cardImages.cover144,
                'Sheep and Goat': cardImages.cover145
              };
              coverUrl = map4[dn];
            }else if (currentDisplay === 'Horticulture Crops') {
              const map5 = {
                'Flowers': cardImages.cover161,
                'Fruit Crops': cardImages.cover162,
                'Mixed Crops': cardImages.cover163,
                'Others': cardImages.cover164,
                'Plantation Crops': cardImages.cover165,
                'Spices': cardImages.cover166,
                'Tuber Crops': cardImages.cover167,
                'Vegetables': cardImages.cover168
              };
              coverUrl = map5[dn];
            }else if (currentDisplay === 'Working') {
              const map6 = {
                'People': cardImages.cover191,
                'With Bullock': cardImages.cover192,
                'With Machinery': cardImages.cover193
              };
              coverUrl = map6[dn];
            }
            return (
              <NavCard key={d.name} to={`/downloads${d.path.replace('/api','')}`} name={dn} coverUrl={coverUrl} />
            );
          })}
        </div>
      ) : (
        <div className="image-grid">
          {data.items.map(img => (
            <ImageCard
              key={img.name}
              name={img.name}
              imageUrl={img.imageUrl}
              viewRel={img.viewRel}
              downloadUrl={img.downloadUrl}
            />
          ))}
        </div>
      )}
    </div>
  );
}

